var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useRef } from 'react';
import { DateRangePicker } from 'react-date-range';
import { useTranslation } from 'react-i18next';
import { enGB } from 'date-fns/locale';
import moment from 'moment';
import staticRangesGenerator from '../../../utils/LocaleUtil';
import { defaultInputRanges } from '../../../utils/LocaleInputUtil';
import { CustomButton } from '../button/button';
import ChevronDown from '../../../assets/icons/ic-chevron-down.svg';
import DayPicker from 'react-day-picker';
import { isSameDay } from 'date-fns';
import { some } from 'lodash';
import './dropdown.scss';
var staticRanges = staticRangesGenerator(enGB);
var inputRanges = defaultInputRanges();
export var CustomDropdown = function (props) {
    var defaultText = props.defaultText, icon = props.icon, options = props.options, onSelect = props.onSelect, showDropdown = props.showDropdown, value = props.value, isShowDropdowIcon = props.isShowDropdowIcon, isHideInput = props.isHideInput, defaultOption = props.defaultOption, disabled = props.disabled;
    var _a = useState(defaultText ? defaultText : ""), labelDropdown = _a[0], setLabelDropDown = _a[1];
    var _b = useState(), optionDropdowns = _b[0], setOptionDropdown = _b[1];
    var _c = useState(false), isShowFilter = _c[0], setShowFilter = _c[1];
    var _d = useState(false), isDisabled = _d[0], setDisabled = _d[1];
    var useOutsideAlerter = function (ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowFilter(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };
    useEffect(function () {
        setLabelDropDown(defaultText ? defaultText : "");
    }, []);
    useEffect(function () {
        if (options) {
            setOptionDropdown(options);
            var valueOption_1 = value ? value : "";
            var optionValue = options.find(function (option) { return option.value == valueOption_1; });
            setLabelDropDown(optionValue ? optionValue.label : "");
        }
    }, [options, value]);
    useEffect(function () {
        setShowFilter(showDropdown ? showDropdown : false);
    }, [showDropdown]);
    useEffect(function () {
        setDisabled(disabled == true ? true : false);
    }, [disabled]);
    var dropdownRef = useRef(null);
    useOutsideAlerter(dropdownRef);
    var showFilter = function (event) {
        if (!isDisabled) {
            event.preventDefault();
            setShowFilter(!isShowFilter);
        }
    };
    var onClickDropdown = function (option) {
        setLabelDropDown(option.label);
        var opts = options.filter(function (optionDropdown) { return optionDropdown.value != option.value; });
        setOptionDropdown(opts);
        onSelect(option);
        setShowFilter(false);
        if (props.onHideDropdown) {
            props.onHideDropdown();
        }
    };
    return (React.createElement("div", { className: "dropdown-container", ref: dropdownRef },
        !isHideInput ?
            React.createElement("div", { className: "btn-filter " + (isDisabled ? "btn-filter-disabled" : ""), onClick: showFilter },
                icon ? React.createElement("img", { src: icon, className: "icon-btn" }) : null,
                React.createElement("span", null, labelDropdown),
                isShowDropdowIcon ? React.createElement("img", { src: ChevronDown, alt: "ic-dropdown" }) : null)
            : null,
        isShowFilter ?
            React.createElement("ul", { className: "btn-filter-options" },
                defaultOption ? React.createElement("li", { key: 'default-option', className: "btn-filter-option", onClick: function (event) { return onClickDropdown(defaultOption); } }, defaultOption.label) : null,
                optionDropdowns.map(function (option, index) {
                    return React.createElement("li", { key: index, className: "btn-filter-option", onClick: function (event) { return onClickDropdown(option); } }, option.label);
                }))
            : null));
};
export var CustomDateRange = function (props) {
    var t = useTranslation().t;
    var icon = props.icon, onSelect = props.onSelect, showDropdown = props.showDropdown, duration = props.duration, minDate = props.minDate, inputDuration = props.inputDuration, onStaticRangeChange = props.onStaticRangeChange, staticRange = props.staticRange, maxDate = props.maxDate;
    var _a = useState(false), isShowFilter = _a[0], setShowFilter = _a[1];
    var _b = useState(duration), dateRange = _b[0], setDateRange = _b[1];
    var _c = useState(duration), dateRangeTmp = _c[0], setDateRangeTmp = _c[1];
    var _d = useState(staticRanges), staticDateRanges = _d[0], setStaticDateRanges = _d[1];
    var _e = useState(), selectedRange = _e[0], setSelectedRange = _e[1];
    var useOutsideAlerter = function (ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowFilter(false);
                    if (props.onHideDatePicker) {
                        props.onHideDatePicker();
                    }
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };
    var datePickerRef = useRef(null);
    useOutsideAlerter(datePickerRef);
    useEffect(function () {
        if (staticRange && staticDateRanges && staticDateRanges.length) {
            compareStaticRange(staticRange);
        }
    }, [staticRange, staticDateRanges]);
    var compareStaticRange = function (range) {
        var selectedRange = staticDateRanges.find(function (staticRange) {
            if (staticRange.label === range) {
                return true;
            }
        });
        if (selectedRange && selectedRange.range()) {
            var selectedRangeDate = selectedRange.range();
            selectedRangeDate.key = 'selection';
            setDateRange([selectedRangeDate]);
            setDateRangeTmp([selectedRangeDate]);
            onSelect([selectedRangeDate]);
        }
    };
    useEffect(function () {
        setDateRange(duration);
        setDateRangeTmp(duration);
        compareDateRange(duration[0]);
    }, [duration]);
    useEffect(function () {
        setShowFilter(showDropdown);
    }, [showDropdown]);
    useEffect(function () {
        if (props.customStaticRanges) {
            setStaticDateRanges(props.customStaticRanges);
        }
    }, [props.customStaticRanges]);
    var showFilter = function (event) {
        setShowFilter(!isShowFilter);
    };
    var onDateRangeChanged = function (dateRange) {
        // setDateRange([dateRange.selection]);
        if (dateRange && dateRange.selection) {
            var dateRangeData = __assign({}, dateRange.selection);
            var minDate_1 = new Date(new Date().getFullYear() - 2, 0, 1);
            var startDateCheck = moment(dateRangeData.startDate);
            var endDateCheck = moment(dateRangeData.endDate);
            var minDateCheck = moment(minDate_1);
            var isCheckStartDate = startDateCheck.diff(minDateCheck) > 0 ? true : false;
            var isCheckEndDate = endDateCheck.diff(minDateCheck) > 0 ? true : false;
            if (!isCheckEndDate) {
                dateRangeData.endDate = minDate_1;
            }
            if (!isCheckStartDate) {
                dateRangeData.startDate = minDate_1;
            }
            if (maxDate) {
                var startDateMaxCheck = moment(dateRangeData.startDate);
                var endDateMaxCheck = moment(dateRangeData.endDate);
                var minDateMaxCheck = moment(maxDate);
                var isCheckStartDateMax = startDateMaxCheck.diff(minDateMaxCheck) < 0 ? true : false;
                var isCheckEndDateMax = endDateMaxCheck.diff(minDateMaxCheck) < 0 ? true : false;
                if (!isCheckEndDateMax) {
                    dateRangeData.endDate = maxDate;
                }
                if (!isCheckStartDateMax) {
                    dateRangeData.startDate = maxDate;
                }
            }
            setDateRangeTmp([dateRangeData]);
            compareDateRange(dateRangeData);
        }
    };
    var compareDateRange = function (dateRange) {
        var range = staticRanges.find(function (staticRange) {
            var range = staticRange.range();
            if (isSameDay(range.startDate, dateRange.startDate) &&
                isSameDay(range.endDate, dateRange.endDate)) {
                return true;
            }
        });
        setSelectedRange(range);
    };
    var onApplyDateRange = function () {
        setShowFilter(false);
        setDateRange(dateRangeTmp);
        onSelect(dateRangeTmp);
        if (onStaticRangeChange) {
            onStaticRangeChange(selectedRange);
        }
    };
    var onCancelDateRange = function () {
        setShowFilter(false);
        setDateRange(duration);
        if (props.onHideDatePicker) {
            props.onHideDatePicker();
        }
    };
    var renderDurationName = function () {
        var txtDuration = "";
        if (dateRange && dateRange.length) {
            txtDuration = moment(dateRange[0].startDate).format('LL') + ' - ' + moment(dateRange[0].endDate).format('LL');
        }
        else {
            txtDuration = t('dashboard.last_month');
        }
        return txtDuration;
    };
    return (React.createElement("div", { className: "dropdown-date-range-container", ref: datePickerRef },
        !props.isHidePickerButton ?
            React.createElement("div", { className: "btn-filter btn-date-range-picker", onClick: showFilter },
                React.createElement("img", { src: icon, className: "icon-btn" }),
                React.createElement("span", { className: "label-top-icon" }, renderDurationName()))
            : null,
        isShowFilter ? React.createElement("div", { className: "date-range-picker" },
            React.createElement(DateRangePicker, { onChange: function (item) { return onDateRangeChanged(item); }, moveRangeOnFirstSelection: false, months: 2, locale: enGB, staticRanges: staticDateRanges, inputRanges: inputDuration ? inputDuration : inputRanges, ranges: dateRangeTmp, minDate: minDate ? minDate : undefined, maxDate: maxDate ? maxDate : undefined, direction: "horizontal", dateDisplayFormat: 'yyyy/MM/dd', editableDateInputs: true }),
            React.createElement("div", { className: "btn-date-range-container" },
                React.createElement(CustomButton, { className: "btn-date-picker btn-primary", onClick: onApplyDateRange, label: "Apply" }),
                React.createElement(CustomButton, { className: "btn-date-picker", onClick: onCancelDateRange, label: "Cancel" }))) : null));
};
export var CustomCalendar = function (props) {
    var t = useTranslation().t;
    var icon = props.icon, onSelect = props.onSelect, showDropdown = props.showDropdown, date = props.date, ranges = props.ranges;
    var _a = useState(false), isShowDatePicker = _a[0], setShowDatePicker = _a[1];
    var _b = useState(date), selectedDate = _b[0], setSelectedDate = _b[1];
    useEffect(function () {
        setSelectedDate(date);
    }, [date]);
    useEffect(function () {
        setShowDatePicker(showDropdown);
    }, [showDropdown]);
    var showDatePicker = function (event) {
        setShowDatePicker(!isShowDatePicker);
    };
    var useOutsideAlerter = function (ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowDatePicker(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };
    var datePickerRef = useRef(null);
    useOutsideAlerter(datePickerRef);
    var handleSelect = function (date) {
        console.log(date);
        // setSelectedDate(date);
    };
    var renderDurationName = function () {
        var txtDuration = "";
        if (selectedDate) {
            txtDuration = moment(selectedDate).format('LL');
        }
        else {
            txtDuration = t('dashboard.last_month');
        }
        return txtDuration;
    };
    var onApplyDateSelection = function () {
        onSelect(selectedDate);
        setShowDatePicker(false);
    };
    var onCancelDateSelection = function () {
        setShowDatePicker(false);
    };
    return (React.createElement("div", { className: "dropdown-date-range-container", ref: datePickerRef },
        React.createElement("div", { className: "btn-filter btn-date-range-picker", onClick: showDatePicker },
            React.createElement("img", { src: icon, className: "icon-btn" }),
            React.createElement("span", { className: "label-top-icon" }, renderDurationName())),
        isShowDatePicker ? React.createElement("div", { className: "date-range-picker" },
            React.createElement(DateRangePicker, { onChange: function (item) { return handleSelect(item); }, ranges: ranges, locale: enGB, staticRanges: staticRanges }),
            React.createElement("div", { className: "btn-date-range-container" },
                React.createElement(CustomButton, { className: "btn-date-picker btn-primary", onClick: onApplyDateSelection, label: "Apply" }),
                React.createElement(CustomButton, { className: "btn-date-picker", onClick: onCancelDateSelection, label: "Cancel" }))) : null));
};
export var CustomDaypicket = function (props) {
    var t = useTranslation().t;
    var showDropdown = props.showDropdown, icon = props.icon, day = props.day, onSelect = props.onSelect;
    var _a = useState(false), isShowDayPicker = _a[0], setShowDayPicker = _a[1];
    var _b = useState([]), selectedDays = _b[0], updateSelectedDate = _b[1];
    var _c = useState([]), selectedDay = _c[0], setSelectedDay = _c[1];
    var _d = useState([]), dateData = _d[0], setDateData = _d[1];
    useEffect(function () {
        setSelectedDay(day);
    }, [day]);
    useEffect(function () {
        setShowDayPicker(showDropdown);
    }, [showDropdown]);
    var showDatePicker = function (event) {
        setShowDayPicker(!isShowDayPicker);
    };
    var useOutsideAlerter = function (ref) {
        useEffect(function () {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowDayPicker(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    };
    var datePickerRef = useRef(null);
    useOutsideAlerter(datePickerRef);
    var handleSelect = function (date) {
        console.log(date);
        // setSelectedDate(date);
    };
    var renderDurationName = function () {
        var txtDuration = "";
        if (selectedDay) {
            txtDuration = moment(selectedDay).format('LL');
        }
        else {
            txtDuration = t('dashboard.last_month');
        }
        return txtDuration;
    };
    var renderDay = function (day) {
        var date = day.getDate();
        var events = dateData ? dateData.filter(function (eventDay) {
            var eventDate = new Date(eventDay.eventDate).getDate();
            return date == eventDate;
        }) : null;
        var enableNote = some(selectedDays, function (item) { return isSameDay(item, day); });
        return (React.createElement("div", { className: "date-container" },
            React.createElement("div", { className: "day-item" }, date)));
    };
    var handleDayClick = function (day) {
        setSelectedDay(day);
        onSelect(day);
        setShowDayPicker(false);
    };
    return (React.createElement("div", { className: "dropdown-date-range-container", ref: datePickerRef },
        React.createElement("div", { className: "btn-filter btn-date-range-picker", onClick: showDatePicker },
            React.createElement("img", { src: icon, className: "icon-btn" }),
            React.createElement("span", { className: "label-top-icon" }, renderDurationName())),
        isShowDayPicker ? React.createElement("div", { className: "date-range-picker" },
            React.createElement(DayPicker, { className: "calendar-style", modifiers: {
                    selected: function (day) {
                        return some(selectedDays, function (item) { return isSameDay(item, day); });
                    }
                }, renderDay: renderDay, onDayClick: handleDayClick })) : null));
};
export var ActionDropdown = function (props) {
    var icon = props.icon, _a = props.isDisabled, isDisabled = _a === void 0 ? false : _a, _b = props.isShowDropdownIcon, isShowDropdownIcon = _b === void 0 ? true : _b, _c = props.defaultText, defaultText = _c === void 0 ? "Actions" : _c, options = props.options;
    var _d = useState(false), isShowFilter = _d[0], setShowFilter = _d[1];
    var dropdownRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowFilter(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () { return document.removeEventListener("mousedown", handleClickOutside); };
    }, []);
    var handleToggleDropdown = function (e) {
        e.preventDefault();
        if (!isDisabled)
            setShowFilter(function (prev) { return !prev; });
    };
    return (React.createElement("div", { className: "action-dropdown-container", ref: dropdownRef },
        React.createElement("div", { className: "btn-action-dropdown " + (isDisabled ? "btn-action-dropdown-disabled" : ""), onClick: handleToggleDropdown },
            icon && React.createElement("img", { src: icon, className: "icon-btn", alt: "dropdown-icon" }),
            React.createElement("span", null, defaultText),
            isShowDropdownIcon && React.createElement("img", { src: ChevronDown, alt: "ic-dropdown" })),
        isShowFilter && (React.createElement("ul", { className: "btn-action-dropdown-options" }, options.map(function (option, index) { return (React.createElement("li", { key: index, className: "btn-action-dropdown-option", onClick: function () {
                option.action();
                setShowFilter(false);
            } }, option.label)); })))));
};
